import React from 'react';

import { DatePicker, DatePickerProps } from 'antd';

type EZDatePickerProps = Omit<DatePickerProps, 'mask'> & {};

export const EZDatePicker: React.FC<EZDatePickerProps> = ({ ...props }) => {
    return <DatePicker {...props} showTime={false} />;
};
